// extracted by mini-css-extract-plugin
export default {"input":"w8-z","button":"x8-z","selected":"y8-z","unavailable":"z8-z","oos":"A8-z","image":"B8-z","paperCutDisabledOverlay":"C8-z"};